(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReportMaterialCategory', PatchReportMaterialCategory);

    PatchReportMaterialCategory.$inject = ['$resource'];

    function PatchReportMaterialCategory ($resource) {
        var resourceUrl =  'api/patch-report-material-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
